export const REGIONS = {
    YUNLIN: "雲林縣",
    CHANGHUA: "彰化縣"
};

export const REPORT_ICONS = {
    OFFLINE: '11',
    NORMAL: ['0', '2'],
    SPEED: ['206', '207'],
    BRAKE: ['208', '209'],
    TURN: ['227', '228'],
    POWER: '193'
};